(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["beam-product-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.beam-product-gallery').forEach((gallery) => {
    const inputs = Array.from(gallery.querySelectorAll('.beam-product-gallery__input'));
    const thumbnails = Array.from(gallery.querySelectorAll('.beam-product-gallery__thumbnails button'));
    const imageLinks = Array.from(gallery.querySelectorAll('.beam-product-gallery__image > a'));
    const viewer = gallery.querySelector('.beam-product-gallery__viewer');
    let viewerIndex = 0;
    let returnFocus;
    const showEnlarged = (index) => {
      viewerIndex = (index + imageLinks.length) % imageLinks.length;
      const link = imageLinks[viewerIndex];
      const img = viewer.querySelector('.beam-product-gallery__enlarged');
      img.src = link.href;
      img.alt = link.querySelector('img').alt;
      viewer.querySelector('.beam-product-gallery__caption').textContent = img.alt;
      viewer.querySelector('.beam-product-gallery__count').textContent = `${viewerIndex + 1} / ${imageLinks.length}`;
    };
    imageLinks.forEach((link, index) => link.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      returnFocus = link;
      showEnlarged(index);
      viewer.showModal();
      viewer.focus({ preventScroll: true });
      viewer.scrollTop = 0;
    }));
    viewer.querySelector('.beam-product-gallery__viewer-close').addEventListener('click', () => viewer.close());
    viewer.querySelector('.beam-product-gallery__viewer-prev')?.addEventListener('click', () => showEnlarged(viewerIndex - 1));
    viewer.querySelector('.beam-product-gallery__viewer-next')?.addEventListener('click', () => showEnlarged(viewerIndex + 1));
    viewer.addEventListener('click', (event) => {
      if (event.target !== viewer) return;
      const bounds = viewer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) viewer.close();
    });
    viewer.addEventListener('close', () => returnFocus?.focus({ preventScroll: true }));
    viewer.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      event.stopPropagation();
      showEnlarged(event.key === 'Home' ? 0 : event.key === 'End' ? imageLinks.length - 1 : viewerIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    const select = (index) => {
      const active = (index + inputs.length) % inputs.length;
      inputs[active].checked = true;
      thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
      return active;
    };
    gallery.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-image-index]');
      if (!button) return;
      const wasArrow = button.classList.contains('beam-product-gallery__arrow');
      const previous = button.classList.contains('beam-product-gallery__arrow--previous');
      select(Number(button.dataset.imageIndex) - 1);
      if (wasArrow) gallery.querySelector('.beam-product-gallery__image:nth-child(' + (inputs.findIndex(input => input.checked) + 1) + ') .beam-product-gallery__arrow--' + (previous ? 'previous' : 'next')).focus({ preventScroll: true });
    });
    gallery.addEventListener('keydown', (event) => {
      if (inputs.length < 2) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const current = inputs.findIndex(input => input.checked);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? inputs.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
      thumbnails[select(next)].focus({ preventScroll: true });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["beam-product-heading"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.beam-product-heading').forEach((heading) => {
    const information = heading.closest('.product-information');
    const grid = information?.querySelector('.product-information__grid');
    if (!grid) return;
    const originalPosition = document.createComment('Beam desktop product heading');
    heading.before(originalPosition);
    const share = heading.querySelector('.beam-product-share');
    const dialog = document.getElementById(share?.getAttribute('aria-controls'));
    if (share && dialog) {
      share.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('.beam-share-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => share.focus());
      dialog.querySelector('.beam-share-copy').addEventListener('click', async () => {
        const input = dialog.querySelector('input');
        const status = dialog.querySelector('.beam-share-status');
        try { await navigator.clipboard.writeText(input.value); status.textContent = 'Link copied.'; }
        catch { input.focus(); input.select(); status.textContent = 'Select and copy the product link above.'; }
      });
    }
    const phone = window.matchMedia('(max-width: 767.98px)');
    const placeHeading = () => {
      if (phone.matches) grid.before(heading);
      else originalPosition.after(heading);
    };
    phone.addEventListener('change', placeHeading);
    placeHeading();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-information').forEach((productInformation) => {
    const preparePrint = () => {
      document.querySelectorAll('body > .beam-product-print-sheet').forEach((sheet) => sheet.remove());
      const sheet = document.createElement('article');
      sheet.className = 'beam-product-print-sheet';
      sheet.id = 'beam-product-print-sheet';
      const copyContent = (source) => {
        const copy = source.cloneNode(true);
        copy.querySelectorAll('script, style, button, dialog, iframe, video, audio, input, select, nav, .skip-to-content-link, .skip-to-product-info, a[href^="#"], .beam-product-read-more, .beam-product-actions, .beam-product-support, .beam-related-products, .beam-product-video, .beam-product-document, .beam-product-accordion, .beam-product-mobile-toggle').forEach((element) => element.remove());
        // Discard storefront layout and collapsed-tab attributes in the copy only.
        const elements = [copy, ...copy.querySelectorAll('*')];
        const featureCopies = new Set(copy.querySelectorAll('.beam-product-feature > div'));
        elements.forEach((element) => {
          const printRole = element.matches('.beam-product-feature') ? 'feature' :
            element.matches('.beam-product-feature__image') ? 'feature-image' :
            featureCopies.has(element) ? 'feature-copy' :
            element.matches('.beam-product-capabilities') ? 'capabilities' :
            element.matches('.tableBlock') ? 'table' :
            element.matches('td.heading, th') ? 'table-heading' : null;
          const columnSpan = element.getAttribute('colspan');
          const rowSpan = element.getAttribute('rowspan');
          Array.from(element.attributes).forEach((attribute) => {
            if (!['src', 'srcset', 'sizes', 'alt', 'href'].includes(attribute.name)) element.removeAttribute(attribute.name);
          });
          if (printRole) element.setAttribute(`data-print-${printRole}`, '');
          if (columnSpan) element.setAttribute('colspan', columnSpan);
          if (rowSpan) element.setAttribute('rowspan', rowSpan);
          if (element.tagName === 'DETAILS') element.open = true;
          if (element.tagName === 'IMG') element.loading = 'eager';
        });
        return copy;
      };
      const brand = document.createElement('div');
      brand.setAttribute('data-print-brand', '');
      brand.textContent = 'BEAM COMMUNICATIONS';
      sheet.appendChild(brand);
      const heading = productInformation.querySelector('h1');
      if (heading) sheet.appendChild(copyContent(heading));
      const firstProductImage = productInformation.querySelector('.beam-product-gallery__image img');
      if (firstProductImage) {
        const figure = document.createElement('figure');
        figure.setAttribute('data-print-product-image', '');
        figure.appendChild(copyContent(firstProductImage));
        sheet.appendChild(figure);
      }
      const description = productInformation.querySelector('.product-details rte-formatter');
      if (description) {
        const section = document.createElement('section');
        const title = document.createElement('h2');
        title.textContent = 'Product information';
        section.append(title, copyContent(description));
        sheet.appendChild(section);
      }
      productInformation.querySelectorAll('.beam-product-tabs [role="tab"]').forEach((tab) => {
        if (!/^(Features|Specifications)$/i.test(tab.textContent.trim())) return;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) {
          const copy = copyContent(panel);
          copy.setAttribute(`data-print-${tab.textContent.trim().toLowerCase()}`, '');
          const heading = copy.querySelector('h2');
          if (heading) heading.textContent = tab.textContent.trim();
          sheet.appendChild(copy);
        }
      });
      document.body.appendChild(sheet);
    };
    productInformation.querySelector('.beam-product-print')?.addEventListener('click', async () => {
      preparePrint();
      await Promise.race([
        Promise.all(Array.from(document.querySelectorAll('#beam-product-print-sheet img'), (image) => image.decode().catch(() => {}))),
        new Promise((resolve) => setTimeout(resolve, 4000))
      ]);
      window.print();
    });
    window.addEventListener('beforeprint', () => {
      if (!document.getElementById('beam-product-print-sheet')) preparePrint();
    });
    window.addEventListener('afterprint', () => {
      document.querySelectorAll('body > .beam-product-print-sheet').forEach((sheet) => sheet.remove());
    });
    const richText = productInformation.querySelector('.product-details rte-formatter');
    if (!richText || richText.dataset.beamSectionsMoved === 'true') return;
    richText.querySelectorAll('p').forEach((paragraph) => {
      // Legacy non-breaking-space paragraphs carry visible vertical spacing.
      if (!paragraph.textContent.includes('\u00a0') && !paragraph.textContent.trim() && !paragraph.querySelector('img, video, iframe, svg, input')) paragraph.remove();
    });

    const start = Array.from(richText.children).find((element) => {
      return element.matches('.beam-product-accordion, .beam-product-feature, .beam-product-video') ||
        (element.tagName === 'H2' && /^(features|specifications|brochures|accessories)$/i.test(element.textContent.trim()));
    });
    const support = productInformation.querySelector('.beam-product-support');
    if (!start && !support) return;

    const section = document.createElement('div');
    section.className = 'beam-product-detail-sections';
    section.id = 'beam-product-features';
    section.setAttribute('aria-label', 'Product details');
    let current = start;
    while (current) {
      const next = current.nextElementSibling;
      section.appendChild(current);
      current = next;
    }
    productInformation.appendChild(section);
    section.querySelectorAll('.beam-accessory-intro img').forEach((image) => {
      ['width', 'height'].forEach((dimension) => {
        const value = image.getAttribute(dimension);
        if (value && /^\d+(?:\.\d+)?$/.test(value) && Number(value) > 0 && Number(value) <= 5000) {
          image.style.setProperty(`--beam-accessory-${dimension}`, `${Number(value)}px`);
        }
      });
    });
    const tabBar = document.createElement('div');
    tabBar.className = 'beam-product-tabs';
    tabBar.setAttribute('role', 'tablist');
    tabBar.setAttribute('aria-label', 'Product information');
    const featurePanel = document.createElement('div');
    featurePanel.className = 'beam-product-tab-panel';
    const accordionSections = Array.from(section.querySelectorAll(':scope > .beam-product-accordion'));
    Array.from(section.children).filter((child) => !accordionSections.includes(child)).forEach((child) => featurePanel.appendChild(child));
    Array.from(featurePanel.querySelectorAll(':scope > .beam-product-feature, :scope > .beam-product-video, :scope > .beam-related-products')).forEach((block, index) => {
      if (block.classList.contains('beam-product-video')) block.classList.toggle('beam-product-video--blue', index % 2 === 0);
      if (block.classList.contains('beam-related-products')) block.classList.toggle('beam-related-products--blue', index % 2 === 0);
    });
    const hasFeatures = Array.from(featurePanel.children).some((child) => child.tagName !== 'H2' && (child.textContent.trim() || child.querySelector('img, iframe, video')));
    const entries = hasFeatures ? [{ label: 'Features', panel: featurePanel }] : [];
    const title = productInformation.querySelector('h1')?.textContent.trim().replace(/\s*\([^)]*\)\s*$/, '') || '';
    if (featurePanel.querySelector('h2')) featurePanel.querySelector('h2').textContent = `${title} Features`;
    accordionSections.forEach((accordion) => {
      const label = accordion.querySelector('summary')?.textContent.trim();
      const content = accordion.querySelector('.beam-product-accordion__content');
      if (!label || !content) return;
      const panel = document.createElement('div');
      panel.className = 'beam-product-tab-panel';
      const heading = document.createElement('h2');
      heading.textContent = label === 'Specifications' ? `${title} Specifications` : label;
      panel.append(heading, content);
      entries.push({ label, panel });
      accordion.remove();
    });
    if (support) {
      // The legacy resources table is a visual grid, not tabular data.
      // Keep every resource and download intact while presenting a semantic list.
      support.querySelectorAll('[data-support-section="resource"] table').forEach((table) => {
        const cells = Array.from(table.querySelectorAll('td')).filter((cell) => cell.querySelector('a[href]'));
        if (!cells.length) return;
        const list = document.createElement('ul');
        list.className = 'beam-resource-list';
        cells.forEach((cell) => {
          const item = document.createElement('li');
          while (cell.firstChild) item.appendChild(cell.firstChild);
          list.appendChild(item);
        });
        // Preserve any remaining non-resource content rather than discarding it.
        table.before(list);
        if (!table.textContent.trim() && !table.querySelector('img, a[href]')) table.remove();
      });
      // Restore the legacy FAQ topic selector without its Joomla tabber dependency.
      support.querySelectorAll('.jwts_tabber').forEach((faq, faqIndex) => {
        const topics = Array.from(faq.querySelectorAll(':scope > .jwts_tabbertab'));
        if (!topics.length) return;
        faq.classList.add('beam-support-faq');
        const navigation = document.createElement('div');
        navigation.className = 'beam-support-topics';
        navigation.setAttribute('role', 'tablist');
        navigation.setAttribute('aria-label', 'FAQ topics');
        navigation.setAttribute('aria-orientation', 'vertical');
        const content = document.createElement('div');
        const buttons = [];
        const selectTopic = (selected, focus = false) => {
          topics.forEach((topic, index) => {
            topic.hidden = index !== selected;
            buttons[index].setAttribute('aria-selected', String(index === selected));
            buttons[index].tabIndex = index === selected ? 0 : -1;
          });
          if (focus) buttons[selected].focus();
        };
        topics.forEach((topic, index) => {
          const heading = topic.querySelector('.jwts_heading');
          const label = topic.getAttribute('title') || heading?.textContent.trim() || `Topic ${index + 1}`;
          if (heading) heading.textContent = label;
          const id = `beam-faq-${productInformation.id}-${faqIndex}-${index}`;
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = label;
          button.id = `${id}-tab`;
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', `${id}-panel`);
          topic.id = `${id}-panel`;
          topic.setAttribute('role', 'tabpanel');
          topic.setAttribute('aria-labelledby', button.id);
          button.addEventListener('click', () => selectTopic(index));
          button.addEventListener('keydown', (event) => {
            let target;
            if (['ArrowDown', 'ArrowRight'].includes(event.key)) target = (index + 1) % topics.length;
            if (['ArrowUp', 'ArrowLeft'].includes(event.key)) target = (index - 1 + topics.length) % topics.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = topics.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            selectTopic(target, true);
          });
          buttons.push(button);
          navigation.appendChild(button);
          content.appendChild(topic);
        });
        faq.append(navigation, content);
        selectTopic(0);
      });
      const supportPanel = document.createElement('div');
      supportPanel.className = 'beam-product-tab-panel beam-product-tab-panel--support';
      supportPanel.appendChild(support);
      const accessoriesIndex = entries.findIndex((entry) => entry.label === 'Accessories');
      entries.splice(accessoriesIndex < 0 ? entries.length : accessoriesIndex + 1, 0, { label: 'Support', panel: supportPanel });
    }
    if (!entries.length) { section.remove(); return; }
    const phoneLayout = window.matchMedia('(max-width: 767.98px)');
    let selectedPanel = 0;
    const selectTab = (selectedIndex, focus = false) => {
      selectedPanel = selectedIndex;
      entries.forEach((entry, index) => {
        entry.panel.hidden = index !== selectedIndex;
        entry.button.setAttribute('aria-selected', String(index === selectedIndex));
        entry.button.tabIndex = index === selectedIndex ? 0 : -1;
        entry.mobileButton?.setAttribute('aria-expanded', String(index === selectedIndex));
      });
      if (focus) entries[selectedIndex].button.focus();
    };
    entries.forEach((entry, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = entry.label;
      button.id = `${productInformation.id || 'beam-product'}-tab-${index}`;
      entry.panel.id = `${button.id}-panel`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', entry.panel.id);
      entry.panel.setAttribute('role', 'tabpanel');
      entry.panel.setAttribute('aria-labelledby', button.id);
      button.addEventListener('click', () => selectTab(index));
      button.addEventListener('keydown', (event) => {
        const next = event.key === 'ArrowRight' ? (index + 1) % entries.length : event.key === 'ArrowLeft' ? (index + entries.length - 1) % entries.length : event.key === 'Home' ? 0 : event.key === 'End' ? entries.length - 1 : null;
        if (next !== null) { event.preventDefault(); selectTab(next, true); }
      });
      entry.button = button;
      tabBar.appendChild(button);
      const mobileButton = document.createElement('button');
      mobileButton.type = 'button';
      mobileButton.className = 'beam-product-mobile-toggle';
      mobileButton.textContent = entry.label;
      mobileButton.id = `${button.id}-mobile`;
      mobileButton.setAttribute('aria-controls', entry.panel.id);
      mobileButton.addEventListener('click', () => {
        selectTab(selectedPanel === index ? -1 : index);
        mobileButton.scrollIntoView({ block: 'nearest' });
      });
      entry.mobileButton = mobileButton;
      section.appendChild(mobileButton);
      section.appendChild(entry.panel);
    });
    section.prepend(tabBar);
    selectTab(0);
    const updateLayout = () => {
      if (!phoneLayout.matches && selectedPanel < 0) selectTab(0);
      entries.forEach((entry) => {
        entry.panel.setAttribute('role', phoneLayout.matches ? 'region' : 'tabpanel');
        entry.panel.setAttribute('aria-labelledby', phoneLayout.matches ? entry.mobileButton.id : entry.button.id);
      });
    };
    phoneLayout.addEventListener('change', updateLayout);
    updateLayout();
    const showSupport = () => {
      const supportIndex = entries.findIndex((entry) => entry.label === 'Support');
      if (supportIndex < 0) return;
      selectTab(supportIndex);
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    productInformation.querySelector('.beam-product-actions__support')?.addEventListener('click', showSupport);
    window.addEventListener('hashchange', () => { if (window.location.hash === '#product-support') showSupport(); });
    if (window.location.hash === '#product-support') showSupport();
    if (hasFeatures && !richText.querySelector('.beam-product-read-more')) {
      const readMore = document.createElement('a');
      readMore.className = 'beam-product-read-more';
      readMore.href = '#beam-product-features';
      readMore.textContent = 'Read more product features';
      richText.appendChild(readMore);
    }
    richText.querySelector('.beam-product-read-more')?.addEventListener('click', (event) => {
      event.preventDefault();
      selectTab(0);
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      (phoneLayout.matches ? entries[0].mobileButton : entries[0].button).focus({ preventScroll: true });
    });
      section.querySelectorAll('.beam-product-reviews-preview [data-beam-tab]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = entries.find((entry) => entry.label === link.dataset.beamTab);
          if (!target) return;
          event.preventDefault();
          selectTab(entries.indexOf(target));
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          (phoneLayout.matches ? target.mobileButton : target.button).focus({ preventScroll: true });
        });
      });
      richText.dataset.beamSectionsMoved = 'true';
  });
  } catch(e) { console.error(e); }
})();

})();
